/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Mini-game ad format configuration
 * @export
 * @interface MiniGameConfig
 */
export interface MiniGameConfig {
    /**
     * 
     * @type {string}
     * @memberof MiniGameConfig
     */
    templateId: string;
    /**
     * 
     * @type {string}
     * @memberof MiniGameConfig
     */
    configJson?: string;
    /**
     * 
     * @type {number}
     * @memberof MiniGameConfig
     */
    scoreThreshold?: number;
    /**
     * 
     * @type {number}
     * @memberof MiniGameConfig
     */
    maxDurationSeconds?: number;
}

/**
 * Check if a given object implements the MiniGameConfig interface.
 */
export function instanceOfMiniGameConfig(value: object): value is MiniGameConfig {
    if (!('templateId' in value) || value['templateId'] === undefined) return false;
    return true;
}

export function MiniGameConfigFromJSON(json: any): MiniGameConfig {
    return MiniGameConfigFromJSONTyped(json, false);
}

export function MiniGameConfigFromJSONTyped(json: any, ignoreDiscriminator: boolean): MiniGameConfig {
    if (json == null) {
        return json;
    }
    return {
        
        'templateId': json['templateId'],
        'configJson': json['configJson'] == null ? undefined : json['configJson'],
        'scoreThreshold': json['scoreThreshold'] == null ? undefined : json['scoreThreshold'],
        'maxDurationSeconds': json['maxDurationSeconds'] == null ? undefined : json['maxDurationSeconds'],
    };
}

export function MiniGameConfigToJSON(json: any): MiniGameConfig {
    return MiniGameConfigToJSONTyped(json, false);
}

export function MiniGameConfigToJSONTyped(value?: MiniGameConfig | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'templateId': value['templateId'],
        'configJson': value['configJson'],
        'scoreThreshold': value['scoreThreshold'],
        'maxDurationSeconds': value['maxDurationSeconds'],
    };
}

